import { projectsCollection, projectGroupCollection } from "./firebase";

// Fetch projects: all or by ID
export const fetchProjects = async (id) => {
  if (id) {
    const doc = await projectsCollection.doc(id).get();
    if (doc.exists) {
      return { ...doc.data(), id: doc.id, firestoreId: doc.id };
    }
    throw new Error("Projects not found");
  }

  const snapshot = await projectsCollection.get();
  return snapshot.docs.map((doc) => ({
    ...doc.data(),
    id: doc.id,
    firestoreId: doc.id,
  }));
};

export const fetchProjectGroups = async (forSelection = false) => {
  const snapshot = await projectGroupCollection.get();

  if (forSelection) {
    // Return formatted data for selection
    return snapshot.docs
      .map((doc) => ({
        label: doc.data().projectName,
        value: doc.id,
        clientId: doc.data().client,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically
  }

  // Return complete project group data
  return snapshot.docs.map((doc) => ({
    ...doc.data(),
    id: doc.id,
    firestoreId: doc.id,
  }));
};

export const fetchUnlinkedProjects = async () => {
  const snapshot = await projectsCollection
    .where("addToExistingProject", "==", "")
    .get();

  const data = snapshot.docs.map((doc) => ({
    ...doc.data(),
    id: doc.id,
  }));
  return data;
};

export const fetchLinkedProjects = async (groupId) => {
  const snapshot = await projectsCollection
    .where("addToExistingProject", "==", groupId)
    .get();
  return snapshot.docs.map((doc) => ({
    ...doc.data(),
    id: doc.id,
  }));
};

export const fetchLinkedCompanies = async (companyID) => {
  try {
    const snapshot = await projectsCollection
      .where("client", "==", companyID)
      .get();
    if (snapshot.empty) {
      return [];
    }

    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error fetching linked projects:", error);
    return [];
  }
};
